import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import Button from "../../../styles/atoms/Button";
import Icon from "../../../styles/Icon";
import useUscInsuranceCalculatorButton from "../../../../../hooks/uscUscInsuranceCalculatorButton";
import type { UscTrackingLocation } from "../../../../../utils/tracking";
import { trackCta } from "../../../../../utils/tracking";

/**
 * In the first phase of the PDP rework the add insurance button will still open the insurance calculator
 * In the second phase this button will link to the insurance in page
 */
const UscAddInsuranceButton = ({ trackingLocation }: { trackingLocation: UscTrackingLocation }): JSX.Element => {
    const vehicleType = useUscSelector((state) => state.vehicle.type);
    const buttonLabel = useUscLabel("uscBasketCtaAddInsurance");
    const { showInsuranceCalculator } = useUscInsuranceCalculatorButton();

    return (
        <Button
            variant="basket-cta"
            onClick={() => {
                trackCta("insurance-calculator", trackingLocation, vehicleType);
                showInsuranceCalculator();
            }}
        >
            <Icon variant="insurance" />
            {buttonLabel}
        </Button>
    );
};

export default UscAddInsuranceButton;
